// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	CancelButton: 'cancel-button',
	SaveButton: 'save-button',
	ApplyHstCheckbox: 'apply-hst-checkbox',
	IncludeAllDetailsInDocumentCheckbox:
		'include-all-details-in-document-checkbox',
	MonthlyFees: 'monthly-fees',
	VendorShare: 'vendor-share',
	VendorWillHavePaid: 'vendor-will-have-paid',
	CreditVendor: 'credit-vendor',
	CreditPurchaser: 'credit-purchaser',
	VendorWillHavePaidFullAmountRadioGroup:
		'vendor-will-have-paid-full-amount-radio-group',
} as const;
